function setHeaderHeightVar() {
  const headerHeight = document.querySelector('[data-header]').offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);

  // reset on resize, debounced
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.documentElement.style.setProperty('--header-height', `0px`);
      setHeaderHeightVar();
    }, 100, {passive: true});
  });
}

export { setHeaderHeightVar };